import { createFileRoute } from '@tanstack/react-router'
import { RoleTemplates } from '../components/access/RoleTemplates.tsx'
import { RolesPanel } from '../components/platform/SettingsPanels.tsx'

/** Role templates (access to give in one go), then the roles themselves. */
export const Route = createFileRoute('/_authed/_shell/settings/roles')({
  component: RolesScreen,
})

function RolesScreen() {
  return (
    <div className="max-w-2xl space-y-8">
      <RoleTemplates />
      <RolesPanel />
    </div>
  )
}
